import React from 'react';
import { Reveal } from './Reveal';
import { bonuses } from '../data/bonuses';
export function BonusesSection() {
  return <section className="bg-brand-dark px-4 py-20 md:py-28" data-id="element-17" data-mp="gwx5x4ldv9es">
      <Reveal className="mx-auto max-w-3xl" data-id="element-18" data-mp="vsmmuobpowcn">
        <div className="mb-12 text-center" data-id="element-19" data-mp="vuh863qwaqh9">
          <div className="inline-flex rounded-full bg-brand-teal/15 px-4 py-2 text-[10px] font-extrabold tracking-[0.14em] text-brand-teal" data-id="element-20" data-mp="qtt8yusij3by">
            INCLUDED FREE TODAY
          </div>
          <h2 className="mt-4 text-3xl font-black text-brand-blue md:text-4xl" data-id="element-21" data-mp="14r82obpstx9q">🎁 5 Exclusive Bonuses</h2>
          <p className="mt-4 text-brand-gray" data-id="element-22" data-mp="1eje0i22qf8wu">
            Valued at <span className="font-bold text-brand-purple line-through" data-id="element-23" data-mp="1eiukws0k0wlz">$97 USD</span> — yours at no extra cost
            today.
          </p>
        </div>
        <div className="space-y-3" data-id="element-24" data-mp="1njkc1ievdytd">
          {bonuses.map((bonus, index) => <article key={bonus.title} className="flex items-center gap-4 rounded-2xl border border-brand-blue/[0.06] bg-brand-alt p-4 shadow-sm sm:gap-5" data-id="element-25" data-mp="1jigxr0ch0au9" data-mpi={index}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-blue font-serif font-bold text-white" data-id="element-26" data-mp="3trxbhcjtq3ip">
                {index + 1}
              </span>
              <img src={bonus.image} alt={`Cover of ${bonus.title}`} className="h-20 w-14 shrink-0 rounded-md border border-brand-dark object-cover shadow-sm sm:h-24 sm:w-[4.25rem]" data-id="element-27" data-mp="2nytxy07zl6j" />
              <div className="min-w-0 flex-1" data-id="element-28" data-mp="gkc0ic37u268">
                <h3 className="font-bold leading-snug text-brand-blue" data-id="element-29" data-mp="gj0xiehlgyg6">{bonus.title}</h3>
                <p className="mt-1 text-xs" data-id="element-30" data-mp="le6ty78mhvii">
                  <span className="text-brand-gray" data-id="element-31" data-mp="qbq5v0hulw7a">{bonus.description}</span>
                  <span className="ml-2 font-semibold text-brand-purple line-through" data-id="element-32" data-mp="va9wvfbaty6i">value {bonus.price}</span>
                  <span className="ml-2 font-extrabold text-brand-teal" data-id="element-33" data-mp="1094kqvo4icxh">FREE</span>
                </p>
              </div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}